function loadScopioCollection(collection, container, callback) {

  // Build the request url of each page
  var urlRequest = "/collections/" + collection + "/?view=json-50";

  // Stores the images retrieved by the endpoint
  var result;

  var heightDesktop = window.innerWidth / 5;
  var estimatedWidth = "600";

  $.ajax({
    type: "GET",
    url: urlRequest,
    // On success execute the following function
    success: function (container, callback, json) {
      // Store the response on the result variable
      result = JSON.parse(json);

      var urls = result.data;

      if(mobilecheck() === true) {
        heightDesktop = window.innerWidth / 2;
      } else {
        heightDesktop = window.innerWidth / 5;
      }

      if(mobilecheck() === true) {
        estimatedWidth = "600";
      } else {
        estimatedWidth = "300";
      }

      for( i=0; i<urls.length; i++){
        var str = urls[i].img_url;
        var imgPath = urls[i].handle;
        var imgTitle = urls[i].title;
        var res = str.replace("{width}", estimatedWidth);
        container.insertAdjacentHTML('beforeend',
                                     '<div><a class="jg-entry jg-entry-visible" href="https://scop.io/products/'+imgPath+'"><img src="'+ res +'" loading="lazy"></a><div class="caption">'+imgTitle+'</div></div>');
      }

      // Invoke the library that sets all the configurations to show the grid
      $(container).justifiedGallery({
        rowHeight : heightDesktop,
        lastRow : 'nojustify',
        margins : 6
      });

      if(callback) {
        callback();
      }
    }.bind(null, container, callback)
  });
}

function justifyCollection(containerId) {
  var heightDesktop = window.innerWidth / 5;

  var maxRowHeight = null;

  if(mobilecheck() === true) {
    heightDesktop = 200;
    maxRowHeight = 320;
  } else {
    heightDesktop = 300;
    maxRowHeight = 480;
  }

  try {
    $('#' + containerId).justifiedGallery({
      lastRow : 'nojustify',
      margins : 6,
      border: 10,
      rowHeight: heightDesktop,
      maxRowHeight: maxRowHeight,
      waitThumbnailsLoad: false,
      sizeRangeSuffixes: {
        'lt100':'_100x',
        'lt240':'_240x',
        'lt320':'_320x',
        'lt500':'_500x',
        'lt640':'_640x',
        'lt1024':'_1024x',
        'lt1280':'_1280x',
      },
      getSize: function(photo) {
        return {
          width: photo.dataset.width,
          height: photo.dataset.height,
        };
      }
    });
  } catch (e) {
    console.log('container ' + containerId + ' null.');
  }
}
